import { computed, Ref } from "@vue/composition-api";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";
import { ROLES } from "@/const";

export default function useRole(user: Ref<User | UserPublicData | null | undefined>) {
  const isAdmin = computed(() => checkRole(user?.value?.role || "", ROLES.ADMIN));
  const isMember = computed(() => checkRole(user?.value?.role || "", ROLES.MEMBER));
  const isCreator = computed(() => checkRole(user?.value?.role || "", ROLES.CREATOR));
  const isFullCreator = computed(() => checkRole(user?.value?.role || "", ROLES.FULL_CREATOR));
  const isTalentAgent = computed(() => checkRole(user?.value?.role ?? "", ROLES.TALENT_AGENT));
  const isAnyCreator = computed(() => checkRole(user?.value?.role ?? "", [ROLES.CREATOR, ROLES.FULL_CREATOR]));

  return {
    isAdmin,
    isMember,
    isCreator,
    isFullCreator,
    isTalentAgent,
    isAnyCreator,
  };
}
